import { type ReactElement, type ReactNode, useState } from 'react';

interface ModalButtonWrapperProps {
  className?: string;
  children: (props: { onClick: () => void }) => ReactNode;
  renderModal: (props: { isOpen: boolean; onClose: () => void }) => ReactNode;
}

export function ModalButtonWrapper({
  className,
  children,
  renderModal,
}: ModalButtonWrapperProps): ReactElement {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={className}>
      {children({ onClick: () => setIsOpen((prev) => !prev) })}
      {isOpen && renderModal({ isOpen, onClose: () => setIsOpen(false) })}
    </div>
  );
}
